import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row g-xl-5 g-3" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAddProduct',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const AddTab = defineAsyncComponent(() => import("@/components/theme/ecommerce/addproduct/AddTab.vue"))
const AddProductContent = defineAsyncComponent(() => import("@/components/theme/ecommerce/addproduct/AddProductContent.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-12",
        headerTitle: "true",
        titles: "true",
        title: "Product Form "
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(AddTab)),
            _createVNode(_unref(AddProductContent))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})